/**
 * Admin Cities Page
 * Manage cities within geographic regions
 */

import { createFileRoute } from '@tanstack/react-router'
import { CitiesSection } from '@ufc/domains/cities'

export const Route = createFileRoute('/admin/cities')({
  component: CitiesPage,
})

function CitiesPage() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <CitiesSection />
    </div>
  )
}
